import { useState } from 'react';
import { useIdleTimer } from "react-idle-timer"

const useIdleTimeout  = () => {

    const [isIdle,setIdle] = useState(false);
    const handleIdle = () => setIdle(true);
    
    useIdleTimer({
        timeout: 3*60*1000,
        onIdle: handleIdle,
        debounce: 500
    })
    return {
        isIdle,
    }
};

export default useIdleTimeout ;